import React, { FC } from 'react';
import { MemoryRouter } from 'react-router-dom';

import Router from './routes/Router';
import { I18nProvider } from './contexts/I18nContext';

const App: FC = () => (
  <I18nProvider>
    <MemoryRouter>
      <Router />
    </MemoryRouter>
  </I18nProvider>
);

export default App;
